import React, { useEffect, useState } from 'react';
import { Slider } from '@mui/material';

import './GameSettings.css';

const minBetAmount = 0.01;
const maxBetAmount = 5;
const stepBetAmount = 0.01;
const minRows = 8;
const maxRows = 16;

export default function GameSettings({
  betAmount, setBetAmount,
  ballsCount, setBallsCount,
  rows, setRows,
  risk, setRisk,
  animation, setAnimation,
  sound, setSound,
  outcome, setOutcome,
  betClick,
  gameStatus,
}) {
  const [betAmountSubBtnState, setBetAmountSubBtnState] = useState(['disable', 'disable', '', '']);

  const generateBetAmountSubBtnState = (newBetAmount) => {
    let tmpBetAmountSubBtnState = ['', '', '', ''];
    if (newBetAmount === minBetAmount) {
      tmpBetAmountSubBtnState[0] = 'disable';
    }
    if ((newBetAmount / 2) < minBetAmount) {
      tmpBetAmountSubBtnState[1] = 'disable';
    }
    if ((newBetAmount * 2) > maxBetAmount) {
      tmpBetAmountSubBtnState[2] = 'disable';
    }
    if (newBetAmount === maxBetAmount) {
      tmpBetAmountSubBtnState[3] = 'disable';
    }

    return tmpBetAmountSubBtnState;
  };

  const betAmountChange = (event) => {
    let newBetAmount = event.target.value;
    newBetAmount = Math.min(Math.max(Number(newBetAmount).toFixed(2), minBetAmount), maxBetAmount);
    setBetAmount(newBetAmount);
    setBetAmountSubBtnState(generateBetAmountSubBtnState(newBetAmount));
  };

  const minBetAmountClick = (event) => {
    if (event.target.className.includes('disable'))
      return;

    setBetAmount(minBetAmount);
    setBetAmountSubBtnState(['disable', 'disable', '', '']);
  };

  const halfBetAmountClick = (event) => {
    if (event.target.className.includes('disable'))
      return;
      
    let newBetAmount = (betAmount / 2).toFixed(2);
    setBetAmount(newBetAmount);
    setBetAmountSubBtnState(generateBetAmountSubBtnState(newBetAmount));
  };

  const doubleBetAmountClick = (event) => {
    if (event.target.className.includes('disable'))
      return;
      
    let newBetAmount = (betAmount * 2).toFixed(2);
    setBetAmount(newBetAmount);
    setBetAmountSubBtnState(generateBetAmountSubBtnState(newBetAmount));
  };

  const maxBetAmountClick = (event) => {
    if (event.target.className.includes('disable'))
      return;
      
    setBetAmount(maxBetAmount);
    setBetAmountSubBtnState(['', '', 'disable', 'disable']);
  };

  useEffect(() => {
    let tmpBetAmountSubBtnState = ['', '', '', ''];
    if (gameStatus % 2) {
      tmpBetAmountSubBtnState = ['disable', 'disable', 'disable', 'disable'];
    } else {
      tmpBetAmountSubBtnState = generateBetAmountSubBtnState(betAmount);
    }
    setBetAmountSubBtnState(tmpBetAmountSubBtnState);
  }, [gameStatus, betAmount]);

  return (
    <div className="game-settings">
      <div>
        <div>
          <label>Bet Amount</label>
          <input
            type="number"
            onBlur={betAmountChange}
            onChange={(event) => {setBetAmount(event.target.value);}}
            value={betAmount}
            min={minBetAmount}
            max={maxBetAmount}
            step={stepBetAmount}
            disabled={gameStatus % 2 ? true : false} />
          <div className='betamount-subbtn'>
            <span className={betAmountSubBtnState[0]} onClick={minBetAmountClick} disabled={gameStatus % 2 ? true : false}>MIN</span>
            <span className={betAmountSubBtnState[1]} onClick={halfBetAmountClick} disabled={gameStatus % 2 ? true : false}>×0.5</span>
            <span className={betAmountSubBtnState[2]} onClick={doubleBetAmountClick} disabled={gameStatus % 2 ? true : false}>×2</span>
            <span className={betAmountSubBtnState[3]} onClick={maxBetAmountClick} disabled={gameStatus % 2 ? true : false}>MAX</span>
          </div>
        </div>
        <div>
          <label>Balls Count</label>
          <input type="number" onChange={(event) => {setBallsCount(event.target.value)}} value={ballsCount} min={1} disabled={gameStatus % 2 ? true : false}></input>
          {/* <input type="number" onChange={(event) => {setBallsCount(event.target.value)}} value={ballsCount} min={1} disabled={true}></input> */}
        </div>
        <div>
          <div className='rows-label'>
            <label>Rows</label>
            <label>{rows}</label>
          </div>
          <Slider
            id="plinko_rows"
            value={rows}
            min={minRows}
            max={maxRows}
            size="small"
            valueLabelDisplay="auto"
            sx={{
              '& .MuiSlider-rail, & .MuiSlider-track, & .MuiSlider-thumbColorPrimary': {
                backgroundColor: '#FABC51',
              },
              '& .MuiSlider-thumbColorPrimary:hover, & .css-14gf62f-MuiSlider-thumb.Mui-focusVisible': {
                boxShadow: '0px 0px 0px 8px #8d7e657a',
              },
              '& .MuiSlider-thumbColorPrimary:active': {
                boxShadow: '0px 0px 0px 14px #8d7e657a',
              },
              '& .MuiSlider-valueLabel': {
                backgroundColor: 'white',
                color: 'black',
              },
            }}
            disabled={gameStatus % 2 ? true : false}
            onChange={(event) => {setRows(event.target.value);}} />
        </div>
        <div>
          <label>Risk</label>
          <div className='game-risk-btn-container'>
            <button
              className={risk === 'low' ? 'game-risk-btn game-risk-btn-active' : 'game-risk-btn'}
              onClick={() => {setRisk('low')}}
              disabled={gameStatus % 2 ? true : false}>
              Low
            </button>
            <button
              className={risk === 'medium' ? 'game-risk-btn game-risk-btn-active' : 'game-risk-btn'}
              onClick={() => {setRisk('medium')}}
              disabled={gameStatus % 2 ? true : false}>
              Medium
            </button>
            <button
              className={risk === 'high' ? 'game-risk-btn game-risk-btn-active' : 'game-risk-btn'}
              onClick={() => {setRisk('high')}}
              disabled={gameStatus % 2 ? true : false}>
              High
            </button>
          </div>
        </div>
        <div className='game-animation-toggle-container'>
          <label>Animation</label>
          <div className='game-animation-toggle'>
            <input
              type="checkbox"
              id="animation"
              disabled={gameStatus % 2 ? true : false}
              defaultChecked='checked'
              onChange={(event) => {
                var tmp = (animation === 'On' ? 'Off' : 'On');
                setAnimation(tmp);
              }}
            />
            <label htmlFor="animation">Toggle</label>  
          </div>
        </div>
        <div className='game-animation-toggle-container'>
          <label>Sound</label>
          <div className='game-animation-toggle'>
            <input
              type="checkbox"
              id="sound"
              disabled={gameStatus % 2 ? true : false}
              defaultChecked='checked'
              onChange={(event) => {
                var tmp = (sound === 'On' ? 'Off' : 'On');
                setSound(tmp);
              }}
            />
            <label htmlFor="sound">Toggle</label>  
          </div>
        </div>
        {/* <div>
          <label>Outcome</label>
          <input
            type="text"
            onChange={(event) => {setOutcome(event.target.value);}}
            value={outcome}
            disabled={gameStatus % 2 ? true : false} />
        </div> */}
      </div>
      <div>
        <button
          className='game-bet-btn'
          onClick={betClick}
          disabled={gameStatus % 2 ? true : false}>
          Bet
        </button>
      </div>
    </div>
  );
}
